import React from "react";

// Types
import { VoteTypes, voteTypeOptions } from "types/VoteTypes";
// Styles
import SelectHostContainer from "./VoteType.styles";

type Props = {
    voteType: VoteTypes | "";
    setVoteType: (value: VoteTypes | "") => void;
};

export default function SelectVoteType({
    voteType,
    setVoteType,
}: Readonly<Props>) {
    const handleVoteTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = e.target.value as VoteTypes | "";
        setVoteType(selectedValue);
    };

    return (
        <SelectHostContainer>
            <div className={"heading"}>
                <p>SELECT VOTE TYPE</p>
            </div>
            <div className={"dropdownRow"}>
                <select value={voteType} onChange={handleVoteTypeChange}>
                    <option value="" disabled>
                        -- Please select a vote type --
                    </option>
                    {voteTypeOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.value}
                        </option>
                    ))}
                </select>
            </div>
        </SelectHostContainer>
    );
}
